import {
  initialState,
  Actions,
  State,
  UPDATE_CURRENT_USER,
  UPDATE_CURRENT_USER_SUCCESS,
  UPDATE_CURRENT_USER_ERROR,
  RESET_UPDATE_CURRENT_USER,
} from '../../types/user/update-current-user'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_CURRENT_USER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case UPDATE_CURRENT_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case UPDATE_CURRENT_USER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_UPDATE_CURRENT_USER:
      return initialState
    default:
      return state
  }
}

export default reducers
